import {
  Hammer,
  Home,
  Wrench,
  Building2,
  TreePine,
  PaintBucket,
  HardHat,
  Ruler,
  ArrowUpRight,
} from "lucide-react";
import { waLink } from "../lib/constants";

const SERVICES = [
  {
    icon: HardHat,
    title: "Construcción General",
    desc: "Obras desde cero, ampliaciones y proyectos llave en mano con seguimiento integral.",
  },
  {
    icon: Hammer,
    title: "Refacciones",
    desc: "Renovamos espacios respetando la estructura existente y mejorando funcionalidad.",
  },
  {
    icon: Home,
    title: "Remodelaciones",
    desc: "Rediseñamos interiores y exteriores para adaptarlos a tu forma de vivir.",
  },
  {
    icon: TreePine,
    title: "Pérgolas",
    desc: "Pérgolas de madera y metálicas, hechas a medida para galerías, cocheras y patios.",
  },
  {
    icon: Building2,
    title: "Obras Residenciales",
    desc: "Casas, departamentos y dúplex con foco en calidad de terminaciones.",
  },
  {
    icon: Ruler,
    title: "Obras Comerciales",
    desc: "Locales, oficinas y espacios comerciales adaptados a cada rubro.",
  },
  {
    icon: Wrench,
    title: "Mantenimiento",
    desc: "Servicios de mantenimiento general para mantener tu propiedad impecable.",
  },
  {
    icon: PaintBucket,
    title: "Mejoras del Hogar",
    desc: "Pintura, revestimientos y mejoras puntuales con resultados duraderos.",
  },
];

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[var(--fb-bg-alt)] py-20 md:py-32"
    >
      <div className="fb-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-6xl">
          <div className="reveal">
            <span className="eyebrow">Servicios</span>
            <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl text-[var(--fb-ink)] font-medium tracking-tight balance leading-[1.02]">
              Lo que hacemos,
              <br className="hidden sm:block" /> lo hacemos completo.
            </h2>
          </div>
          <p
            className="text-[var(--fb-ink-soft)] text-base md:text-[17px] max-w-md pretty reveal"
            style={{ transitionDelay: "120ms" }}
          >
            Trabajamos con equipos especializados para cada tipo de obra. Pedí
            el servicio que necesités y te armamos un presupuesto sin
            compromiso.
          </p>
        </div>

        <div
          className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4"
          data-testid="services-grid"
        >
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <a
                key={s.title}
                href={waLink(
                  `Hola! Me interesa el servicio de ${s.title}. ¿Podrían pasarme más información y un presupuesto?`
                )}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${i}`}
                className="group relative bg-white border border-[var(--fb-line)] rounded-2xl p-6 md:p-7 transition-all duration-500 hover:bg-[var(--fb-ink)] hover:text-white hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(15,17,21,0.4)] reveal"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--fb-bg-alt)] text-[var(--fb-ink)] group-hover:bg-[var(--fb-accent)] group-hover:text-[var(--fb-ink)] transition-colors">
                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                  <ArrowUpRight
                    className="h-5 w-5 text-[var(--fb-mute)] group-hover:text-white group-hover:rotate-12 transition-all duration-500"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="mt-8 font-display text-xl md:text-[22px] font-semibold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[var(--fb-mute)] group-hover:text-white/70 transition-colors pretty">
                  {s.desc}
                </p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
